import React from 'react';
import styled from 'styled-components';

import { MQ, ZIndex } from '@rover/kibble/styles';
import events from '@rover/react-lib/src/pages/search/SearchPage/analytics';

import { PERF_HACK_IS_CLOSED_GLOBAL } from './Modal.common';
// stringified Close icon, this is just easier than trying to render an imported icon to string
const Close = `
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#1B1F23" viewBox="0 0 32 32">
  <title>close</title>
  <path d="M16 14.586L26.293 4.293a1 1 0 1 1 1.414 1.414L17.414 16l10.293 10.293a1 1 0 0 1-1.414 1.414L16 17.414 5.707 27.707a1 1 0 0 1-1.414-1.414L14.586 16 4.293 5.707a1 1 0 0 1 1.414-1.414L16 14.586z"/>
</svg>`;

const createMarkup = () => {
  return {
    __html: `
<script type="text/javascript">function searchModalCloseHandler(e) {
  document.getElementsByClassName('ReactModal__Content')[0].classList.add('ReactModal__Content--before-close');
  document.getElementsByClassName('ReactModal__Overlay')[0].classList.add('ReactModal__Overlay--before-close');
  window.${PERF_HACK_IS_CLOSED_GLOBAL} = true;
  
  // copy of no-scroll's off code, not harmful if no-scroll hasn't been activated
  document.documentElement.style.width = '';
  document.documentElement.style.position = '';
  document.documentElement.style.top = '';
  document.documentElement.style.overflow = '';
  window.scroll(0, scrollTop);

  setTimeout(function(){
    document.getElementsByClassName('ReactModal__Content')[0].classList.remove('ReactModal__Content--after-open');
    document.getElementsByClassName('ReactModal__Overlay')[0].classList.remove('ReactModal__Overlay--after-open');
    document.body.classList.add('modalClosePerfHack');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(${JSON.stringify(events.SearchOwnerPreferencesCloseEvent)});
  }, 150);
}</script>

<button aria-label="Close Modal" data-qa-id="modal-button-close" role="button" onclick="searchModalCloseHandler(event);">${Close}</button>`,
  };
};

const ButtonWrapper = styled.div`
  position: absolute;
  right: 14px;
  top: 14px;
  z-index: ${ZIndex.MODAL.toString()};

  ${MQ.NOT_XS.toString()} {
    right: 49px;
    top: 41px;
  }

  button {
    height: 32px;
    width: 32px;
    border: 0;
    background: rgba(0, 0, 0, 0);
    cursor: pointer;

    svg {
      fill: rgba(0, 0, 0, 0.2);
      height: 16px;
      width: 16px;

      ${MQ.NOT_XS.toString()} {
        height: 24px;
        width: 24px;
      }
    }
    &:hover {
      svg {
        fill: rgba(0, 0, 0, 0.5);
      }
    }
  }
`;

const SearchPerfHackButton = (): JSX.Element => (
  <ButtonWrapper
    dangerouslySetInnerHTML={createMarkup()} // eslint-disable-line react/no-danger
  />
);

export default SearchPerfHackButton;
